import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableItem } from "./SortableItem";
// import { SortableOverlay } from "./SortableOverlay";
import { useDragNDropList } from "./useDragNDropList";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";

/**
 * DragNDropList Props
 * @param {Object} props
 * @param {React.ReactNode[] | { id: string | number; component: React.ReactNode; }[]} props.items - Um array que pode conter componentes React/JSX ou objetos com { id: string | number, component: React/JSX }.
 * @param {function} [props.onChange] - Uma função opcional que é executada ao final da operação soltar. Recebe os itens ordenados como argumento.
 */

export function DragNDropList({ items, onChange, props }) {
  const {
    sensors,
    itemsToRender,
    // activeItem,
    onDragStart,
    onDragEnd,
    onDragCancel,
  } = useDragNDropList({ items, onChange });

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragCancel={onDragCancel}
      modifiers={[restrictToVerticalAxis]}
      {...props}
    >
      <SortableContext
        items={itemsToRender}
        strategy={verticalListSortingStrategy}
      >
        {itemsToRender.map((item) => {
          return (
            <SortableItem key={item.id} id={item.id}>
              {item.component}
            </SortableItem>
          );
        })}
      </SortableContext>
      {/* TODO fix render only first component version */}
      {/* <SortableOverlay>
        {activeItem ? (
          <SortableItem id={activeItem.id}>{activeItem.component}</SortableItem>
        ) : null}
      </SortableOverlay> */}
    </DndContext>
  );
}
